const CREON_UI_UA = {
  next: "Далі", continue: "Продовжити",
  section: "Дослідження споживачів", required: "Будь ласка, дайте відповідь на запитання.",
  max: (n) => `Оберіть не більше ${n} варіантів.`, other: "Будь ласка, вкажіть",
  placeholder: "Введіть Вашу відповідь…", age: "Вік, років", screenTitle: "Дякуємо",
  saved: "Ваші відповіді збережено.",
  screened: "Відповідно до критеріїв дослідження інтерв’ю не може бути продовжене.",
  network: "Не вдалося зберегти відповіді. Перевірте з’єднання та спробуйте ще раз. Якщо помилка повторюється, надішліть цю інформацію адміністратору.",
  retry: "Повторити", reference: "Номер посилання", visual: "Матеріал дослідження",
  missing: "Зображення дослідження наразі недоступне на сервері.",
  imageLoading: "Зображення завантажується…",
  imageLoadError: "Не вдалося завантажити зображення. Спробуйте ще раз. Якщо помилка повторюється, повідомте адміністратора.",
  seconds: (n) => `Будь ласка, розглядайте зображення ще ${n} секунд.`,
  packA: "Упаковка A", packB: "Упаковка B", current: "Поточна упаковка",
  scaleLow: "Низька", scaleHigh: "Висока",
  cameraStarting: "Підготовка камери для відстеження погляду…",
  cameraReadyTitle: "Перевірка камери",
  cameraReadyBody: "Розташуйте обличчя по центру кадру та зніміть сонцезахисні окуляри або все, що закриває очі.",
  startCalibration: "Почати калібрування",
  calibrationTitle: "Калібрування відстеження погляду",
  calibrationBody: "Дивіться прямо на кожну точку та натисніть на неї п’ять разів. Не рухайте головою, рухайте лише очима.",
  calibrationProgress: (done, total) => `Виконано ${done} із ${total} натискань`,
  calibrationError: "Не вдалося запустити камеру або модель відстеження погляду. Надайте доступ до камери та спробуйте ще раз.",
  retryCalibration: "Повторити запуск камери",
  continueWithoutTracking: "Продовжити без відстеження погляду",
  trackingPreparing: "Підготовка відстеження погляду для зображення…",
  faceChecking: "Пошук обличчя в кадрі…", faceReady: "Обличчя виявлено. Можна починати калібрування.",
  faceMissing: "Обличчя не виявлено. Розташуйте обличчя по центру камери.",
  faceMissingTitle: "Будь ласка, поверніться до камери",
  faceMissingBody: "Вашого обличчя більше не видно. Перед продовженням розташуйтеся по центру кадру.",
  eyewearChecking: "Перевіряємо, чи добре видно обидва ока…",
  eyewearBlocked: "Очі закриті. Зніміть сонцезахисні окуляри, щоб продовжити.",
  eyewearWarningTitle: "Будь ласка, зніміть сонцезахисні окуляри",
  eyewearWarningBody: "Для відстеження погляду обидва ока мають бути добре видимі.",
  desktopOnlyTitle: "Потрібен комп’ютер",
  desktopOnlyBody: "У цьому опитуванні використовується відстеження погляду за допомогою камери, тому його можна пройти лише на настільному комп’ютері або ноутбуці.",
  guideTitle: "Перед початком", cameraGuideTitle: "Розташуйте обличчя по центру",
  cameraGuideBody: "Сядьте перед камерою в добре освітленому місці та тримайте все обличчя в межах кадру.",
  visibilityGuideTitle: "Очі мають бути видимі",
  visibilityGuideBody: "Зніміть сонцезахисні окуляри та тримайте обидва ока відкритими й добре видимими протягом дослідження.",
  calibrationGuideTitle: "Стежте за точками",
  calibrationGuideBody: "Дивіться прямо на кожну точку та натисніть її п’ять разів, не рухаючи головою.",
  reminderStill: "Не рухайте головою", reminderLook: "Дивіться на точку", reminderClick: "Натисніть 5 разів",
  recordingNotice: "Відео з камери записується лише під час показу матеріалів для відстеження погляду та завантажується разом із відповіддю.",
};

export default CREON_UI_UA;
